import axios from "axios";
import config from "../config";

const findEpisodeById = (episodeId) => {
  return axios.get(`${config.findEpisodeByIdEndpoint}?episodeId=${episodeId}`).then((serverRes) => {
    if (serverRes.data) return serverRes.data;
    return { err: "Problem with the request" };
  });
};

const videoService = {
  findEpisodeById
};

export default videoService;
